import React, { useState, useCallback, createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useAsyncDebounce } from "react-table";

import { useGetDDTTableData } from "hooks/case-management/useGetDDTTableData";
import {
  DOWN_DERATE_TABLE_COLUMNS,
  DEFAULT_FILTERS,
  DEFAULT_SORT
} from "components/DownDerateTrackerTable/DownDerateTrackerTableColumns";

const DownDerateTrackerContext = createContext({});
DownDerateTrackerContext.displayName = "DownDerateTrackerContext";

export const DownDerateTrackerProvider = ({ children }) => {
  const [tableState, setTableState] = useState({
    cases: [],
    sortBy: [DEFAULT_SORT],
    columns: DOWN_DERATE_TABLE_COLUMNS,
    filters: DEFAULT_FILTERS,
    totalPageCount: 0,
    totalRowCount: 0,
    rowsPerPage: 50,
    casesCount: 0,
    pageIndex: 0
  });

  const [getTableData, { loading: casesLoading }] = useGetDDTTableData(
    setTableState,
    cases => cases ?? []
  );

  const onFetchDataDebounced = useAsyncDebounce(getTableData, 100);
  const refetchDownDerateTableData = useCallback(() => {
    onFetchDataDebounced(
      tableState.pageIndex,
      tableState.rowsPerPage,
      tableState.sortBy,
      tableState.filters,
      false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tableState.filters,
    tableState.pageIndex,
    tableState.rowsPerPage,
    tableState.sortBy
  ]);

  return (
    <DownDerateTrackerContext.Provider
      value={{
        tableState,
        setTableState,
        casesLoading,
        refetchDownDerateTableData
      }}
    >
      {children}
    </DownDerateTrackerContext.Provider>
  );
};

export function useDownDerateTrackerData() {
  return useContext(DownDerateTrackerContext);
}

DownDerateTrackerProvider.propTypes = {
  children: PropTypes.node
};
